import { GetBrandBySlugViewModel, GetCategoryBySlugViewModel } from '../../types/api'
import { CombinationSlugPageViewModel } from '../../types/cml-api'

export enum PLPPages {
    Brands = 'brands',
    Categories = 'categories',
    Search = 'search',
    Tags = 'tags',
    Facets = 'facets',
    BrandCategoriesCombination = 'brand-categories',
}

export type PurePLPBasicMetasProps = Partial<GetBrandBySlugViewModel> | Partial<GetCategoryBySlugViewModel>

export type PLPBasicMetasProps = PurePLPBasicMetasProps | CombinationSlugPageViewModel

export type PlpSearchParams = { [key: string]: string | string[] | undefined | null }

export interface PLPPageProps {
    params?: { [key: string]: string | string[] | undefined }
    searchParams?: PlpSearchParams
}

export interface PLPBannerProps {
    params?: { [key: string]: string | string[] | undefined }
    searchParams?: PlpSearchParams
    page?: PLPPages
    basicMetas?: PLPBasicMetasProps
}

export type PLPSlug = string
